import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { AppService } from "src/_services/app.service";

@Component({
  selector: "app-commission-event-markets",
  templateUrl: "./commission-event-markets.component.html",
  styleUrls: ["./commission-event-markets.component.scss"],
})
export class CommissionEventMarketsComponent implements OnInit {
  providerId: string = "";
  sportId: string = "";
  competitionId: string = "";
  eventsList: any;
  eventsTableHeaders: string[] = [
    "Event Date",
    "Event Name",
    "Event Id",
    "Competition Name",
    "Status",
  ];
  competitionName: string;

  constructor(
    private appService: AppService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.providerId = this.route.snapshot.params.providerId;
    this.sportId = this.route.snapshot.params.sportId;
    this.competitionId = this.route.snapshot.params.competitionId;
    this.route.queryParams.subscribe((params) => {
      this.competitionName = params["competitionName"];
    });
    this.getEvents();
  }
  getEvents() {
    try {
      this.appService
        .getEventsData(this.providerId, this.sportId, this.competitionId)
        .subscribe((res) => {
          this.eventsList = res.events;
        });
    } catch (err) {
      console.log(err);
    }
  }

  getBetPlaceDate(date: number) {
    return moment(date).format("DD MMM YYYY hh:mm A");
  }

  goto(eventId, eventName) {
    this.router.navigate(
      [
        `administration/commission-markets/${this.providerId}/${this.sportId}/${this.competitionId}/${eventId}`,
      ],
      {
        queryParams: {
          competitionName: this.competitionName,
          eventName: eventName,
        },
      }
    );
  }
}
